export const TypeofCertifications = [
  {
    label: 'Diploma in Regulated Financial Planning',
    value: 'diploma-in-regulated-financial-planning',
  },
  {
    label: 'Diploma in Financial Planning',
    value: 'diploma-in-financial-planning',
  },
  {
    label: 'Chartered Wealth Manager',
    value: 'chartered-wealth-manager',
  },
  {
    label: 'Chartered Financial Planner',
    value: 'chartered-financial-planner',
  },
  {
    label: 'Certified Financial Planner',
    value: 'certified-financial-planner',
  },
  {
    label: 'Certificate in Mortgage Advice',
    value: 'certificate-in-mortgage-advice',
  },
  {
    label: 'Certificate in Equity Release',
    value: 'certificate-in-equity-release',
  },
  {
    label: 'Award in Long Term Care Planning',
    value: 'award-in-long-term-care-planning',
  },
  {
    label: 'Investment Advice Diploma',
    value: 'investment-advice-diploma',
  },
  {
    label: 'Pension Transfer Specialist Certificate',
    value: 'pension-transfer-specialist-certificate',
  },
  {
    label: 'Private Client Investment Management Certificate',
    value: 'private-client-investment-management-certificate',
  },
  {
    label: 'Islamic Finance Qualification',
    value: 'islamic-finance-qualification',
  },
  {
    label: 'Trust and Estate Planning',
    value: 'trust-and-estate-planning',
  },
  {
    label: 'Advance Diploma in Financial Planning',
    value: 'advance-diploma-in-financial-planning',
  },
];

const getLevelOptions = (level: number) => {
  const levels = [];
  for (let i = 1; i <= level; i++) {
    levels.push({
      label: 'Level ' + i,
      value: 'level' + i,
    });
  }
  return levels;
};

export const Leveloptions = {
  'diploma-in-regulated-financial-planning': null,
  'diploma-in-financial-planning': null,
  'chartered-wealth-manager': null,
  'chartered-financial-planner': null,
  'certified-financial-planner': null,
  'certificate-in-mortgage-advice': getLevelOptions(3),
  'certificate-in-equity-release': getLevelOptions(3),
  'award-in-long-term-care-planning': getLevelOptions(3),
  'investment-advice-diploma': getLevelOptions(4),
  'pension-transfer-specialist-certificate': getLevelOptions(6),
  'private-client-investment-management-certificate': getLevelOptions(6),
  'islamic-finance-qualification': getLevelOptions(3),
  'trust-and-estate-planning': getLevelOptions(6),
  'advance-diploma-in-financial-planning': getLevelOptions(6),
};

export const getLevelofCertification = (value: string, typeofCertification: string) => {
  const option = Leveloptions[typeofCertification]?.filter((item) => item.value === value);
  if (option?.length > 0) {
    return option[0];
  }
  return { label: '', value: '' };
};

export const getTypeOfCertification = (value: string) => {
  const option = TypeofCertifications.filter((item) => item.value === value);
  if (option.length > 0) {
    return option[0];
  }
  return { label: '', value: '' };
};
